"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.title = exports.submitButtonLoader = exports.submitButton = exports.subTitle = exports.linkButtonText = exports.headerContent = exports.formSubmitErrorMessage = exports.formSubmitErrorIcon = exports.formSubmitError = exports.confirmationTitle = exports.confirmationHeaderContent = exports.confirmationButtonContainer = exports.cancelButton = exports.buttonDivider = exports.buttonContainerItem = exports.buttonContainer = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var colour = _feBrary.variables.colour,
  font = _feBrary.variables.font;
var confirmationTitle = /*#__PURE__*/(0, _core.css)("text-align:left;margin:30px 0 18px;font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";font-weight:", font.headingFontWeight, ";color:", colour.neutral700, ";line-height:1.27;", (0, _feBrary.media)('>=tablet'), "{text-align:center;}");
exports.confirmationTitle = confirmationTitle;
var confirmationHeaderContent = /*#__PURE__*/(0, _core.css)("text-align:left;margin:20px 0 10px;", (0, _feBrary.media)('>=tablet'), "{text-align:center;display:block;}");
exports.confirmationHeaderContent = confirmationHeaderContent;
var confirmationButtonContainer = /*#__PURE__*/(0, _core.css)("text-align:left;", (0, _feBrary.media)('>=tablet'), "{display:block;}");
exports.confirmationButtonContainer = confirmationButtonContainer;
var buttonContainer = /*#__PURE__*/(0, _core.css)("width:100%;text-align:center;font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";color:", colour.neutral700, ";");
exports.buttonContainer = buttonContainer;
var buttonContainerItem = {
  name: "1kb26de",
  styles: "width:100%;height:40px;"
};
exports.buttonContainerItem = buttonContainerItem;
var title = /*#__PURE__*/(0, _core.css)("font-family:", font.headingFontFamily, ";font-size:", font.h3FontSize, ";color:", colour.neutral700, ";font-weight:", font.headingFontWeight, ";line-height:1.27;margin:0 0 18px;text-align:center;", (0, _feBrary.media)('>=tablet'), "{margin:30px 0 18px;}");
exports.title = title;
var subTitle = /*#__PURE__*/(0, _core.css)("font-family:", font.headingFontFamily, ";font-size:", font.baseFontSize, ";color:", colour.neutral700, ";margin:8px 0 24px;text-align:center;white-space:pre-wrap;");
exports.subTitle = subTitle;
var headerContent = {
  name: "1la5jop",
  styles: "text-align:center;margin:20px 0 10px;"
};
exports.headerContent = headerContent;
var formSubmitError = /*#__PURE__*/(0, _core.css)("padding:10px 20px;font-size:", font.smallFontSize, ";background-color:", colour.errorLight, ";margin-bottom:15px;border-radius:3px;display:table;width:100%;");
exports.formSubmitError = formSubmitError;
var formSubmitErrorIcon = {
  name: "1tnv29r",
  styles: "display:table-cell;text-align:center;vertical-align:middle;padding-right:10px;"
};
exports.formSubmitErrorIcon = formSubmitErrorIcon;
var formSubmitErrorMessage = {
  name: "2qghsv",
  styles: "display:table-cell;"
};
exports.formSubmitErrorMessage = formSubmitErrorMessage;
var submitButton = {
  name: "cecqgz",
  styles: "width:100%;height:40px;margin-bottom:14px;outline:none;"
};
exports.submitButton = submitButton;
var submitButtonLoader = {
  name: "oe4vh5",
  styles: "vertical-align:-4px;"
};
exports.submitButtonLoader = submitButtonLoader;
var cancelButton = /*#__PURE__*/(0, _core.css)("margin-top:20px;line-height:1.27;", (0, _feBrary.media)('>=tablet'), "{display:none;}");
exports.cancelButton = cancelButton;
var buttonDivider = /*#__PURE__*/(0, _core.css)("width:80px;text-align:center;border-top:1px solid ", colour.neutral300, ";margin:10px auto;");
exports.buttonDivider = buttonDivider;
var linkButtonText = /*#__PURE__*/(0, _core.css)("font-weight:", font.headingFontWeight, ";line-height:1.27;white-space:nowrap;");
exports.linkButtonText = linkButtonText;